import styled from 'styled-components';

export const SelectWrapper = styled.div`
  .select:not(.ant-select-dropdown-hidden) {
    top: 0;
    left: 0;
    inset: inherit !important;
  }
  .ant-select-in-form-item {
    height: 40px !important;
  }
`;